// GET
export const GET_RESPONSES = "GET_RESPONSES"
export const GET_RESPONSES_SUCCESS = "GET_RESPONSES_SUCCESS"
export const GET_RESPONSE_BY_ID = "GET_RESPONSE_BY_ID"
export const GET_RESPONSE_BY_ID_SUCCESS = "GET_RESPONSE_BY_ID_SUCCESS"
export const GET_RESPONSES_BY_TEMPALTE_ID = "GET_RESPONSES_BY_TEMPALTE_ID"
export const GET_RESPONSES_BY_TEMPALTE_ID_SUCCESS = "GET_RESPONSES_BY_TEMPALTE_ID_SUCCESS"
export const GET_RESPONSE_BY_USER = "GET_RESPONSE_BY_USER"
export const GET_RESPONSE_BY_USER_SUCCESS = "GET_RESPONSE_BY_USER_SUCCESS"
export const GET_RESPONSE_BY_BUSINESS = "GET_RESPONSE_BY_BUSINESS"
export const GET_RESPONSE_BY_BUSINESS_SUCCESS = "GET_RESPONSE_BY_BUSINESS_SUCCESS"
export const GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID =
  "GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID"
export const GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID_SUCCESS =
  "GET_GLOBAL_RESPONSE_INFORMATION_BY_TEMPLATE_ID_SUCCESS"
export const GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID =
  "GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID"
export const GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID_SUCCESS =
  "GET_GLOBAL_RESPONSE_INFORMATION_BY_RESPONSE_ID_SUCCESS"
// POST

export const ADD_RESPONSE_TO_SIMPLE_FORM = "ADD_RESPONSE_TO_SIMPLE_FORM"
export const ADD_RESPONSE_TO_SIMPLE_FORM_SUCCESS = "ADD_RESPONSE_TO_SIMPLE_FORM_SUCCESS"

export const POST_RESPONSES = "POST_RESPONSES"
export const POST_RESPONSES_SUCCESS = "POST_RESPONSES_SUCCESS"
export const SAVE_RESPONSES = "SAVE_RESPONSES"
export const SAVE_RESPONSES_SUCCESS = "SAVE_RESPONSES_SUCCESS"
export const RESET_ID_SAVE_RESPONSES = "RESET_ID_SAVE_RESPONSES"
// PATCH
export const PATCH_RESPONSES_BY_ID = "PATCH_RESPONSES_BY_ID"
export const PATCH_RESPONSES_BY_ID_SUCCESS = "PATCH_RESPONSES_BY_ID_SUCCESS"
// DELETE
export const DELETE_RESPONSES_BY_ID = "DELETE_RESPONSES_BY_ID"
export const DELETE_RESPONSES_BY_ID_SUCCESS = "DELETE_RESPONSES_BY_ID_SUCCESS"
// FILES IN STORE
export const POST_FILES_FOR_RESPONSE = "POST_FILES_FOR_RESPONSE"
export const POST_FILES_FOR_RESPONSE_SUCCESS = "POST_FILES_FOR_RESPONSE_SUCCESS"
export const DELETE_FILE_FOR_RESPONSE = "DELETE_FILE_FOR_RESPONSE"
